import React from "react";
import "./page2-header.scss";
import { connect } from "react-redux";
const Page2Header = props => {
    let {
        patient: {
            sex,
            birthday,
            name: { name, patronymic, surname }
        },
        HR_RR: { HR, RRmin, RRmax, RRavg },
        organization,
        loc
    } = props;

    HR = HR.val;
    RRmin = RRmin.val;
    RRmax = RRmax.val;
    RRavg = RRavg.val;
    let logo_src = organization?.logo;
    const sSex = sex === "M" ? `[${loc("report.patient.sex.M")}] ` : sex === "F" ? `[${loc("report.patient.sex.F")}] ` : "";
    const sPatName = `${surname} ${name} ${patronymic} ${sSex}${birthday ? birthday + " " + loc("report.patient.DOB") : ""}`;
    const sHR = `${loc("report.params.HR")} ${HR} ${loc("units.bpm_long")}`;
    RRavg = RRavg && RRavg !== null && RRavg !== undefined ? RRavg : "";
    RRmin = RRmin && RRmin !== null && RRmin !== undefined ? RRmin : "";
    RRmax = RRmax && RRmax !== null && RRmax !== undefined ? RRmax : "";
    return (
        <div className="page2-header">
            <div className="page2-header__patient-name">
                <div>
                    <span>{sPatName}</span>
                </div>
            </div>
            <div className="page2-header__HR">
                <div>
                    <span>
                        {sHR}, RR {`${RRavg} (${RRmin} - ${RRmax}) ${loc("units.ms")}`}.
                    </span>
                </div>
            </div>
            <div className="organization_logo_mini">{logo_src ? <img src={logo_src} alt="logo" /> : null}</div>
        </div>
    );
};
const mapStateToProps = ({
    reportApp: {
        reportData: {
            report: {
                patient,
                HR_RR,
                orgHeader: { organization }
            }
        }
    }
}) => {
    return {
        patient,
        HR_RR,
        organization
    };
};
export default connect(mapStateToProps)(Page2Header);
